import { render, staticRenderFns } from "./Configurator.vue?vue&type=template&id=0c21e88f&"
import script from "./Configurator.vue?vue&type=script&lang=js&"
export * from "./Configurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports